export function getTraceIdFromErrorResponse(responseText = '') {
  const traceIdRe = /"traceId":"(.*?)"/;
  const match = responseText.match(new RegExp(traceIdRe))?.[1] ?? '';
  return match;
}
